import { render } from "./OrdersSideBar.vue?vue&type=template&id=509709b4&scoped=true"
import script from "./OrdersSideBar.vue?vue&type=script&lang=js"
export * from "./OrdersSideBar.vue?vue&type=script&lang=js"

import "./OrdersSideBar.vue?vue&type=style&index=0&id=509709b4&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509709b4"]])

export default __exports__